import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';

import messages from '../messages';
import style from './style.module.less';

export const CompleteCheck = () => {
  return (
    <div className={style.completed}>
      <FormattedMessage {...messages.completed} values={{ icon: <FontAwesomeIcon className={style['check-icon']} icon={faCheck} /> }} />
    </div>
  );
};
